import ApplicationController from './application_controller';

export default class extends ApplicationController {
  static values = {
    scrollFormToTop: Boolean
  }

  connect() {
    if (this.scrollFormToTopValue) {
      const scrollTopEl = document.querySelector('.js-scroll-top');
      if (scrollTopEl) {
        scrollTopEl.scroll({ top: 0, behavior: 'smooth' });
      }
    };

    this.timeout = setTimeout(() => {
      this.remove();
    }, 3000);
  }

  disconnect() {
    clearTimeout(this.timeout);
    if (this.element) {
      this.element.remove();
    }
  }

  remove() {
    if (this.element) {
      this.element.classList.add('fade-out');
      setTimeout(() => {
        this.element.parentNode.removeChild(this.element);
        clearTimeout(this.timeout);
      }, 300);
    }
  }
}